import React, { useEffect, useState } from "react";
import l from "components/util/l";
import Modal from "seed/helpers/Modal";
import { usePrototypeDocument } from "components/brief/util/hooks/usePrototypeDocument";
import PreviewFrame from "components/brief/util/helpers/HtmlPreview.sub.PreviewFrame.view";

const DEFAULT_DESKTOP_WIDTH = 1800;
const DEFAULT_DESKTOP_HEIGHT = 700;

const getDesktopViewport = () => ({
  width: window.screen.availWidth,
  height: window.screen.availHeight,
});

const HtmlPreview = ({
  file,
  frameId,
  frameRef = null,
  fullWidth = false,
}) => {

  const [showFullscreen, setShowFullscreen] = useState(false);
  const [desktopViewport, setDesktopViewport] = useState({
    width: DEFAULT_DESKTOP_WIDTH,
    height: DEFAULT_DESKTOP_HEIGHT,
  });

  const { documentUrl, isLoadError } = usePrototypeDocument(file);

  useEffect(() => {

    const updateViewport = () => setDesktopViewport(getDesktopViewport());

    updateViewport();

    window.addEventListener("resize", updateViewport);

    return () => {
      window.removeEventListener("resize", updateViewport);
    };
  }, []);

  return (
    <>
      <div className="card border-0 shadow-sm h-100 overflow-hidden rounded-0 position-relative">
        {file && documentUrl && !isLoadError && !fullWidth && (
          <button
            type="button"
            className="btn btn-sm btn-lighter position-absolute"
            style={{ top: "0.75rem", right: "0.75rem", zIndex: 2 }}
            onClick={() => setShowFullscreen(true)}
            title={l("Pantalla completa%PA589")}
          >
            <i className="fas fa-expand"></i>
          </button>
        )}

        <div className="card-body p-0 d-flex flex-column flex-fill" style={{ minHeight: 0 }}>
          {/* The fullscreen copy replaces this one instead of joining it: two live frames
              means the prototype's scripts, timers and animations run twice over the app. */}
          {!showFullscreen && (
            <PreviewFrame
              desktopViewport={desktopViewport}
              documentUrl={documentUrl}
              frameId={frameId}
              frameRef={frameRef}
              fullWidth={fullWidth}
              hasPrototype={!!file}
              isLoadError={isLoadError}
              padding="1.25rem"
            />
          )}
        </div>
      </div>

      {showFullscreen && (
        <Modal
          width={window.innerWidth - 48}
          height={window.innerHeight - 48}
          overflow="hidden"
          onClose={() => setShowFullscreen(false)}
        >
          <div className="h-100 d-flex flex-column bg-white">
            <PreviewFrame
              desktopViewport={desktopViewport}
              documentUrl={documentUrl}
              frameId={frameId}
              frameRef={frameRef}
              fullWidth={fullWidth}
              hasPrototype={!!file}
              isLoadError={isLoadError}
              padding="1.5rem"
            />
          </div>
        </Modal>
      )}
    </>
  );

};

export default HtmlPreview;
